export default __webpack_public_path__ + "static/media/market.381f6691.svg";